import * as React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useSelector } from 'react-redux';
import SchemaPanel from './schemas/SchemaPanel';
import EventCard from './EventCard';
import { selectSchemas } from '../../redux/flows/schemasSlice';
import { flowEventsSectionStyles as styles } from './styles/flowEventsSectionStyles';

function EventDropZone({ id, sx, children }) {
  const { setNodeRef } = useDroppable({ id });
  return (
    <Box ref={setNodeRef} sx={sx}>
      {children}
    </Box>
  );
}

export default function FlowEventsSection({
  events,
  sortedEventIds,
  onAddEvent,
  onEditEvent,
  onDeleteEvent,
}) {
  const schemas = useSelector(selectSchemas);

  return (
    <Paper sx={styles.eventsPaper}>
      <Box sx={styles.eventsHeader}>
        <Typography variant="h6" sx={styles.schemasHeading}>
          Available Schemas ({schemas.length})
        </Typography>
        <Box sx={styles.eventsHeaderMain}>
          <Typography variant="h6">Events ({events.length})</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAddEvent}
            sx={styles.primaryButton}
          >
            Add Event
          </Button>
        </Box>
      </Box>

      <Box sx={styles.eventsBody}>
        <SchemaPanel />

        <Box sx={styles.eventsList}>
          {events.length === 0 ? (
            <EventDropZone id="flow-events-end" sx={styles.emptyEvents}>
              <Typography>
                No events yet. Drag a schema from the panel or click Add Event.
              </Typography>
            </EventDropZone>
          ) : (
            <SortableContext items={sortedEventIds} strategy={verticalListSortingStrategy}>
              <Box sx={styles.sortableList}>
                {[...events]
                  .sort((a, b) => a.event_order - b.event_order)
                  .map((event) => (
                    <EventCard
                      key={event.event_id}
                      event={event}
                      onEdit={onEditEvent}
                      onDelete={onDeleteEvent}
                    />
                  ))}
                <EventDropZone id="flow-events-end" sx={styles.endZone} />
              </Box>
            </SortableContext>
          )}
        </Box>
      </Box>
    </Paper>
  );
}
